module.exports = __webpack_public_path__ + "static/img/17.da8760e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/17.png
// module id = NYgX
// module chunks = 0